/* eslint-disable no-nested-ternary */
import { AecomDropDownComponent, IMenuItem, LayoutService } from "@aecom/core";
import { Component, OnInit, inject, viewChild } from "@angular/core";
import { Router } from "@angular/router";
import { combineLatest, Subscription } from "rxjs";
import {
  ApplicationNavigation,
  BoroughNavigation,
  DefaultSelection36BoroughPayload,
  DefaultSelection36GlobalModulePayload,
  GlobalNavigation,
  NavigationService,
} from "src/app/api-generated";
import { TPContract } from "src/app/api-generated/model/tPContract";
import LocalContractService from "src/app/services/local-contract.service";
import NavService from "src/app/services/nav.service";
import {
  appitems,
  globalAdmin,
  productMaintitle,
  productName,
  productSubtitle,
} from "src/app/shared/staticValue";
import environment from "src/environments/environment";
import { AuthService } from "@bbj/components";

@Component({
  selector: "app-base",
  templateUrl: "./base.component.html",
  styleUrls: ["./base.component.scss"],
  standalone: false,
})
export default class BaseComponent implements OnInit {
  localContractService = inject(LocalContractService);
  navService = inject(NavService);
  navigationService = inject(NavigationService);
  router = inject(Router);
  authService = inject(AuthService);
  layoutService = inject(LayoutService);

  productname = productName;

  productsubtitle = productSubtitle;

  productmaintitle = productMaintitle;

  appItems: IMenuItem[] = appitems;

  readonly boroughDropDownEL =
    viewChild<AecomDropDownComponent>("boroughDropDown");

  readonly contractDropDownEL =
    viewChild<AecomDropDownComponent>("contractDropDown");

  private boroughList: BoroughNavigation[] = [];

  private globalList: GlobalNavigation[] = [];

  isBoroughMenu = true;

  boroughSelectionList: IMenuItem[] = [];

  boroughSelectionId = "";

  contractSelectionList: IMenuItem[] = [];

  contractSelectionId = "";

  leftNav: IMenuItem[] = [];

  globalNav: IMenuItem[] = [];

  bottomNav: IMenuItem[] = [];

  isBroughManu = true;

  withIcons = true;

  copyright = "© NYC BBJ PROGRAM";

  currentContractId = "";

  subscriptions: Subscription = new Subscription();

  constructor() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit(): void {
    if (!environment.production) {
      this.productmaintitle = `${this.productmaintitle} - 4/27/2022 10:30 AM`;
    }
    this.onDataLoaded();

    this.subscriptions.add(
      combineLatest([
        this.navService.selectedItem$,
        this.localContractService.item$,
      ]).subscribe(([selectedBorough, selectedContract]) => {
        this.resetSideNav(selectedBorough, selectedContract);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onDataLoaded(): void {
    this.boroughList = this.navService.getBroughData().filter((b) => {
      return b.projects.length;
    });

    this.boroughList.sort((a, b) => a.boroughItem.Order - b.boroughItem.Order);
    this.globalList = this.navService.getGlobalData();
    this.globalList.sort((a, b) => a.globalModule.Order - b.globalModule.Order);

    this.globalList.forEach(this.mapGlobalList.bind(this));

    this.resetSideNav(
      this.navService.getSelected(),
      this.localContractService.getItem(),
    );
  }

  mapGlobalList(globalItem: GlobalNavigation): void {
    const subManus: IMenuItem[] = [];

    globalItem.applications.forEach((a) => {
      subManus.push({
        name: BaseComponent.getAppName(a),
        id: a.applicationId,
        url: null,
        externalurl: a.url ?? "/error/comingSoon",
        children: [],
      });
    });

    if (globalItem.globalModule.Order > 99) {
      this.bottomNav.push({
        name: globalItem.globalModule.Name,
        id: globalItem.globalModule.Guid,
        url: globalItem.globalModule.UrlTemplate,
        children: subManus,
        externalicon: `icon-${globalItem.globalModule.Icon}`.replace(
          ".svg",
          "",
        ),
      });
    } else {
      const newNav: IMenuItem = {
        name: globalItem.globalModule.Name,
        id: globalItem.globalModule.Guid,
        children: subManus,
        externalicon: `assets/icons/${globalItem.globalModule.Icon}`,
      };
      if (subManus.length === 0) {
        if (globalItem.globalModule.Embed) {
          newNav.url = globalItem.globalModule.UrlTemplate;
        } else {
          newNav.externalurl = globalItem.globalModule.UrlTemplate;
        }
      }
      this.globalNav.push(newNav);
    }
  }

  resetSideNav(
    selectedBorough:
      | DefaultSelection36BoroughPayload
      | DefaultSelection36GlobalModulePayload,
    selectedContract: TPContract | null,
  ): void {
    this.boroughSelectionList = [];
    this.boroughSelectionId = "";
    this.contractSelectionList = [];
    this.contractSelectionId = "";
    this.leftNav = [];

    this.boroughSelectionList = this.boroughList.map((b) => {
      return {
        id: b.boroughItem.Guid,
        name: b.boroughItem.Name,
        checked: false,
      };
    });

    if (selectedBorough) {
      let activeBorough = this.boroughSelectionList.find((b) => {
        return b.id === selectedBorough.Guid;
      });

      if (!activeBorough && selectedContract) {
        activeBorough = this.boroughSelectionList.find((b) => {
          return b.id === selectedContract.BoroughId;
        });
      }

      if (activeBorough) {
        this.boroughSelectionId = activeBorough.id;
        activeBorough.checked = true;

        const projectList = this.boroughList.find((n) => {
          return n.boroughItem.Guid === activeBorough.id;
        }).projects;

        this.contractSelectionList = projectList.map((p) => {
          return {
            contract: p.contractItem,
            id: p.contractItem.Guid,
            name: p.contractItem.Name,
            checked: false,
          };
        });

        if (selectedContract) {
          const activeProject = this.contractSelectionList.find((c) => {
            return c.id === selectedContract.Guid;
          });

          if (activeProject) {
            this.contractSelectionId = activeProject.id;
            activeProject.checked = true;

            const applicationList = projectList.find((p) => {
              return p.contractItem.Guid === activeProject.id;
            }).applications;

            this.leftNav = applicationList.map((a) => {
              return {
                name: a.applicationName,
                id: a.applicationId,
                url: null,
                externalurl: a.url ?? "/error/comingSoon",
                // icon: `${a.logo} ${a.color}`,
                children: [],
                externalicon: `assets/icons/${a.logo}`,
              };
            });
          }
        }
      }
    }
  }

  onBoroughSelected(e: IMenuItem | IMenuItem[]): void {
    if (e && !Array.isArray(e)) {
      const item = e;
      this.navService.setSelectedId(item.id);

      const selectedBorough = this.boroughList.find((b) => {
        return b.boroughItem.Guid === item.id;
      });

      if (selectedBorough && selectedBorough.projects.length > 0) {
        if (selectedBorough.boroughItem.DefaultContract) {
          const defaultProject = selectedBorough.projects?.find((p) => {
            return (
              p.contractItem.Code ===
              selectedBorough.boroughItem.DefaultContract
            );
          });
          if (defaultProject) {
            this.localContractService.setItem(defaultProject.contractItem);
          } else {
            this.localContractService.setItem(null);
          }
        }
        if (selectedBorough.projects.length === 1) {
          this.localContractService.setItem(
            selectedBorough.projects[0].contractItem,
          );
        }
      } else {
        this.localContractService.setItem(null);
      }
    }
  }

  onContractSelected(e: IMenuItem | IMenuItem[]): void {
    if (e && !Array.isArray(e)) {
      this.localContractService.setItem(e);
    }
  }

  navigate(node: IMenuItem): void {
    if (
      node.id.toLocaleLowerCase() === "f5960107-e029-11eb-a7b4-ace2d34b68ef"
    ) {
      this.unselectOtherNodes(node);
      this.onBoroughSelected(node);
      return;
    }
    if (
      node.id.toLocaleLowerCase() === "f5960497-e029-11eb-a7b4-ace2d34b68ef"
    ) {
      this.unselectOtherNodes(node);
      window.location.href = node.url;
    }
    // console.log(JSON.stringify(node));
    if (node.url && !node.externalurl) {
      this.navigateByUrl(node);
    } else if (node.externalurl || Boolean(node.url)) {
      // eslint-disable-next-line security/detect-non-literal-fs-filename
      window.open(node.externalurl, "_blank");
    } else {
      this.navigateByUrl(node);
    }
  }

  navigateByUrl(node: IMenuItem): void {
    this.unselectOtherNodes(node);
    this.router.navigateByUrl(node.url);
  }

  // eslint-disable-next-line class-methods-use-this
  getContarctBoroughIcon(code: string): string {
    console.log("Code in base", code);
    if (code.includes("QN")) {
      return "qn_contract_icon";
      // eslint-disable-next-line no-else-return
    } else if (code.includes("BK")) {
      return "bk_contract_icon";
    } else if (code.includes("MN")) {
      return "mn_contract_icon";
    } else if (code.includes("BX")) {
      return "bx_contract_icon";
    } else {
      return "";
    }
  }

  static getAppName(appObj: ApplicationNavigation): string {
    switch (appObj.applicationId) {
      case "8a013201-0baf-11ea-917a-027e1b1809fa":
        return appObj.applicationName;
      case "8a013205-0baf-11ea-917a-027e1b1809fa":
        return "AHJV hub";
      default:
        return BaseComponent.capSentence(appObj.applicationName);
    }

    // return BaseComponent.capSentence(appObj.applicationName);
  }

  static capSentence(str: string): string {
    const wordsArray = str.toLowerCase().split(" ");

    const capsArray = wordsArray.map((word) => {
      return word[0].toUpperCase() + word.slice(1);
    });

    return capsArray.join(" ");
  }

  unselectOtherNodes(selected: IMenuItem): void {
    if (this.contains(this.leftNav, selected)) {
      this.uncheckAll(this.globalNav);
    } else if (this.contains(this.globalNav, selected)) {
      this.uncheckAll(this.leftNav);
    }
  }

  private uncheckAll(nodes: IMenuItem[]) {
    nodes.forEach((item) => {
      if (item.children) {
        this.uncheckAll(item.children);
      }

      item.checked = false;
    });
  }

  private contains(nodes: IMenuItem[], selected: IMenuItem) {
    return nodes.some((node) => {
      if (node.id === selected.id) {
        return true;
      }

      if (node.children) {
        return this.contains(node.children, selected);
      }

      return false;
    });
  }

  goToHome(): void {
    if (this.navService.getUser()?.Permissions.includes(globalAdmin)) {
      this.router.navigateByUrl("users");
    } else {
      this.router.navigateByUrl("contracts");
    }
  }
}
